import { render, staticRenderFns } from "./SignUpsFilter.vue?vue&type=template&id=be2cfcee&scoped=true&"
import script from "./SignUpsFilter.vue?vue&type=script&lang=js&"
export * from "./SignUpsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2cfcee",
  null
  
)

export default component.exports